import { render, staticRenderFns } from "./TrialOptionCard.vue?vue&type=template&id=44aff160&scoped=true&"
import script from "./TrialOptionCard.vue?vue&type=script&lang=js&"
export * from "./TrialOptionCard.vue?vue&type=script&lang=js&"
import style0 from "./TrialOptionCard.vue?vue&type=style&index=0&id=44aff160&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aff160",
  null
  
)

export default component.exports